import React, { Component } from 'react';
import Recommend from './Recommend';
import Compare from './Compare';
import Requirement from './Requirement';

class ResearchCenterRecommend extends Component {
    state = {
        cur: 'recommend',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur } = this.state;
        return (
            <div className="full home">
                <div className="tab_flex">
                    <a onClick={() => this.handleBtnClick('recommend')} className={cur == 'recommend' ? 'curr' : ''} >
                        研究中心推荐
                    </a>
                    <a onClick={() => this.handleBtnClick('compare')} className={cur == 'compare' ? 'curr' : ''} >
                        中心入组比较
                    </a>
                    <a onClick={() => this.handleBtnClick('requirement')} className={cur == 'requirement' ? 'curr' : ''} >
                        中心参与项目需求
                    </a>
                </div>
                { cur === 'recommend' && <Recommend /> }
                { cur === 'compare' && <Compare /> }
                { cur === 'requirement' && <Requirement /> }
            </div>
        )
    }
}

export default ResearchCenterRecommend;


// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/index.js